module.exports = __webpack_public_path__ + "static/media/loading3.f9e106d3.gif";